var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "invalid-feedback d-flex align-items-start"
  }, [_c('BaseIcon', {
    staticClass: "mr-1",
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "icon": _setup.icons.warning
    }
  }), _c('div', {
    staticClass: "flex-fill"
  }, [_c('DisplayText', {
    attrs: {
      "text": _vm.errors[0]
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };